"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ngr_exports = {};
__export(ngr_exports, {
  maxEasting: () => maxEasting,
  maxNorthing: () => maxNorthing,
  minEasting: () => minEasting,
  minNorthing: () => minNorthing,
  ngrDigits: () => ngrDigits,
  ngrToOsgb36: () => ngrToOsgb36,
  osgb36ToNgr: () => osgb36ToNgr
});
module.exports = __toCommonJS(ngr_exports);
/**!
 * Ordnance Survey Grid Reference conversion functions.
 *
 * Adapted from the [Geodesy]() library by Chris Veness.
 *
 * [Geodesy]: https://github.com/chrisveness/geodesy/blob/master/osgridref.js
 *
 * @copyright Chris Veness 2005-2020
 * @license MIT
 */
const minEasting = 0;
const minNorthing = 0;
const maxEasting = 699999;
const maxNorthing = 1199999;
const charCodeForA = "A".charCodeAt(0);
function osgb36ToNgr([e, n], digits = 10, spaces = true) {
  if (e < minEasting || e > maxEasting || n < minNorthing || n > maxNorthing) {
    return void 0;
  }
  const e100km = Math.floor(e / 1e5);
  const n100km = Math.floor(n / 1e5);
  let l1 = 19 - n100km - (19 - n100km) % 5 + Math.floor((e100km + 10) / 5);
  let l2 = (19 - n100km) * 5 % 25 + e100km % 5;
  if (l1 > 7) l1++;
  if (l2 > 7) l2++;
  const letterPair = String.fromCharCode(l1 + charCodeForA, l2 + charCodeForA);
  e = Math.floor(e % 1e5 / Math.pow(10, 5 - digits / 2));
  n = Math.floor(n % 1e5 / Math.pow(10, 5 - digits / 2));
  const eString = e.toString().padStart(digits / 2, "0");
  const nString = n.toString().padStart(digits / 2, "0");
  return spaces ? `${letterPair} ${eString} ${nString}` : `${letterPair}${eString}${nString}`;
}
function ngrDigits(ngr) {
  const gridref = ngr.trim().toUpperCase().replace(/\s+/g, "");
  const match = gridref.match(/^[HNST][ABCDEFGHJKLMNOPQRSTUVWXYZ]([0-9]+)$/i);
  if (match == null) {
    return void 0;
  } else {
    const digits = match[1];
    switch (digits.length) {
      case 2:
        return 2;
      case 4:
        return 4;
      case 6:
        return 6;
      case 8:
        return 8;
      case 10:
        return 10;
      default:
        return void 0;
    }
  }
}
function ngrToOsgb36(ngr) {
  const gridref = ngr.trim().toUpperCase().replace(/\s+/g, "");
  let match = gridref.match(/^(\d+),\s*(\d+)$/);
  if (match) return [Number.parseInt(match[1], 10), Number.parseInt(match[2], 10)];
  match = gridref.match(/^[HNST][ABCDEFGHJKLMNOPQRSTUVWXYZ]\s*[0-9]+\s*[0-9]+$/i);
  if (!match) return void 0;
  let l1 = gridref.charCodeAt(0) - charCodeForA;
  let l2 = gridref.charCodeAt(1) - charCodeForA;
  if (l1 > 7) l1--;
  if (l2 > 7) l2--;
  const e100km = (l1 - 2) % 5 * 5 + l2 % 5;
  const n100km = 19 - Math.floor(l1 / 5) * 5 - Math.floor(l2 / 5);
  let en = gridref.slice(2).trim().split(/\s+/);
  if (en.length === 1) {
    en = [en[0].slice(0, en[0].length / 2), en[0].slice(en[0].length / 2)];
  }
  if (en[0].length !== en[1].length) {
    return void 0;
  }
  en[0] = en[0].padEnd(5, "0");
  en[1] = en[1].padEnd(5, "0");
  const e = e100km + en[0];
  const n = n100km + en[1];
  return [parseInt(e, 10), parseInt(n, 10)];
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  maxEasting,
  maxNorthing,
  minEasting,
  minNorthing,
  ngrDigits,
  ngrToOsgb36,
  osgb36ToNgr
});
//# sourceMappingURL=ngr.js.map
